<template>
  <kye-dialog
    :visible="visible"
    v-bind="$attrs"
    v-on="$listeners"
    :title="$attrs.title || '数据导入'"
    :width="$attrs.width || '482px'"
    @open="open"
    :canResize="false"
    :showFullScreenButton="false"
    :before-close="close"
  >
    <slot></slot>
    <div class="kye-data-import">
      <div class="kye-data-import-template-box">
        <div class="download-desc">
          <div class="circle">1</div>
          <p>上传之前，请<span class="bold">下载模版</span>，根据模板格式录入数据</p>
        </div>
        <kye-button @click="downloadTemplate"
                    style="color: var(--g-color-primary);"
                    :disabled="downloadDisabled">
          <i class="layout layout-xiazai"></i>
          下载模板
        </kye-button>
      </div>
      <div class="kye-data-import-upload-box">
        <kye-upload
          :code="code"
          :id="uuid"
          btnType="primary"
          list-type="drag"
          :areaSize="['100%', '106px']"
          :show-file-list="false"
          v-model="list"
          :accept="accept"
          successMsg=""
          :beforeUpload="beforeUpload"
          v-bind="uploadAttrs"
          @success="uploadSuccess"
          @error="uploadError">
          <div class="upload-content">
            <div class="upload-desc">
              <div class="circle">2</div>
              <div>
                <p>录入后<span class="bold">拖拽文件</span>到此处，或<span class="bold">点击上传</span></p>
                <p class="tips">支持Excel(.xls, .xlsx)格式</p>
              </div>
            </div>
            <kye-button icon="layout layout-shangchuan" type="primary">上传文件</kye-button>
          </div>
        </kye-upload>
      </div>
      <div class="kye-data-import-error-row" v-if="errorFileName || showProgress">
        <div class="error-file-box" v-if="errorFileName">
          <div class="error-file-name"><i class="el-icon-document" />{{errorFileName}}</div>
          <el-popover trigger="hover" content="文件异常，请下载查看错误原因" placement="top" v-if="errorFileBtn">
            <kye-button type="text" style="color: var(--g-color-danger)" @click="downloadErrorFile" slot="reference">
              <i class="layout layout-xiazai"></i>异常文件下载
            </kye-button>
          </el-popover>
        </div>
        <div v-if="showProgress" class="progress-box">
          <el-progress
            type="line"
            :percentage="progress"
            :show-text="false"
            color="rgba(142, 113, 199, 0.7)"
            style="margin-top:10px;"></el-progress>
          <p class="progress-text">{{tips}}</p>
        </div>
      </div>
    </div>
  </kye-dialog>
</template>

<script>
  export default {
    name: 'KyeDataImport',
    props: {
      visible: {
        type: Boolean
      },
      code: {
        type: String
      },
      url: {
        type: String
      },
      downloadUrl: {
        type: Function
      },
      params: {
        type: Object,
        default: () => ({})
      },
      accept: {
        type: Array,
        default: () => (['excel', '.xls', '.xlsx', '.et'])
      },
      downloadDisabled: {
        type: Boolean,
        default: false
      },
      isAsync: { // 是否异步导入
        type: Boolean
      },
      time: { // 定时请求间隔时间
        type: Number,
        default: 500
      },
      uploadAttrs: { // 上传组件的透传属性
        type: Object,
        default: () => ({})
      },
      axios: { // 请求修改axios
        type: Object,
        default: () => {
          return {}
        }
      },
      showErrorFile: Boolean, // 是否显示错误文件下载
      beforeSuccess: Function, // 上传成功前的钩子函数
      appkey: [String, Number] // 导入方法的自定义appkey
    },
    data () {
      return {
        uuid: '',
        list: [],
        loading: false,
        disabled: true,
        errorFile: '',
        progress: 0,
        showProgress: false,
        tips: ''
      }
    },
    computed: {
      errorFileName () {
        return this.list[0] ? this.list[0].name : ''
      },
      errorFileBtn () {
        return this.showErrorFile || !this.disabled
      }
    },
    methods: {
      open () {
        this.getUUId()
      },
      async getUUId () {
        let data = await this.$http('system.idcenter.get')
        this.uuid = data
        this.$emit('change', data)
      },
      close () {
        this.$emit('update:visible', false)
        // this.uuid = ''
        this.list = []
        this.disabled = true
        this.loading = false
        this.errorFile = ''
        if (this.isAsync) {
          clearInterval(this.timer)
          this.showProgress = false
          this.progress = 0
        }
      },
      async downloadTemplate () {
        // 2023-03-23 特殊场景，不使用【导入导出】模版功能，用户自定义模版
        if (this.downloadUrl && typeof this.downloadUrl === 'function') {
          this.downloadUrl()
        } else {
          try {
            let data = await this.$http('system.excelTemplate.getFileByCode', { templateCode: this.code })
            window.erpOpen(data.url)
            this.$message.success(`"${data.name || ''}"模版下载成功`)
          } catch (error) {
            this.$message.error('数据模版下载失败，请重新下载')
          }
        }
      },
      beforeUpload (file) {
        this.loading = true
        this.$emit('beforeUpload', file)
      },
      uploadError() {
        this.loading = false
        this.list = []
        this.$emit('error')
      },
      async uploadSuccess () {
        try {
          let data = await this.$http(this.url, { id: this.uuid, ...this.params }, { appkey: this.appkey, ...this.axios })
          let fn = this.beforeSuccess
          if (fn && typeof fn === 'function') {
            let beforeSuccess = fn(data)
            if (beforeSuccess && beforeSuccess.then) {
              beforeSuccess = await beforeSuccess
            }
            if (beforeSuccess === true) {
              this.loading = false
              return
            }
          }
          if (!this.isAsync) {
            this.$message.success('数据导入成功')
            this.$emit('success', data)
            this.close()
          } else {
            if (data.id) {
              this.tips = ''
              this.timer = setInterval(() => {
                this.$http('file.excelImport.get', {
                  id: data.id,
                  _createTime: Date.now()
                }, { log: false }).then(importRes => {
                  if (importRes && importRes.status) {
                    this.tips = importRes.errorMsg
                    if (importRes.status === 20) {
                      this.$emit('success', importRes)
                      this.$message.success('数据导入成功')
                      this.progress = 100
                      this.close()
                    } else if (importRes.status === 10) {
                      this.showProgress = true
                      this.progress += 20
                      if (this.progress > 100) this.progress = 100
                    } else if (importRes.status === 30) {
                      this.$message.error(importRes.errorMsg)
                      this.close()
                    } else if (importRes.status === 40) {
                      this.disabled = true
                      this.loading = false
                      this.loading = false
                      this.$message.error('文件导入数据异常，请下载异常文件查看')
                      clearInterval(this.timer)
                      this.disabled = false
                      this.showProgress = false
                      this.progress = 0
                    }
                  } else {
                    this.$message.error('接口返回参数异常！')
                    this.loading = false
                    this.$emit('error')
                    this.close()
                  }
                }).catch(error => {
                  this.$message.error(error)
                  this.loading = false
                  this.close()
                  this.$emit('error')
                })
              }, this.time)
            } else {
              this.$message('文件导入失败')
              this.loading = false
              this.$emit('error')
              this.close()
            }
          }
        } catch (err) {
          this.loading = false
          this.$emit('error')
          if (err.code === 13610) {
            this.disabled = false
          }
        }
      },
      async downloadErrorFile () {
        let data = await this.$http('file.getByBizCodeAndBizId', { bizCode: 'excel_import_error', bizId: this.uuid })
        window.erpOpen(data[0].url)
      }
    }
  }
</script>

<style lang="less" scoped>
.kye-data-import {
  &-template-box {
    border: 2px dashed var(--g-border-color);
    border-radius: var(--g-border-radius);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 12px;
    margin-bottom: 8px;
    .download-desc {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: var(--g-color-text);
    }
  }
  &-upload-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    height: 106px;
    /deep/ .upload-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 30px 12px;
      .upload-desc {
        display: flex;
        align-items: flex-start;
        font-size: 12px;
        color: var(--g-color-text);
        text-align: left;
        .tips {
          margin-top: 4px;
          color: #9D9CA4;
        }
      }
    }
  }
  &-error-row {
    background: var(--g-bg-gray);
    border-radius: var(--g-border-radius);
    margin-top: 8px;
    padding: 6px 12px;
    .error-file-box {
      display: flex;
      align-items: center;
      // height: 30px;
      justify-content: space-between;
      .error-file-name {
        color: var(--g-color-text);
        font-size: 12px;
        i {
          margin-right: 6px;
        }
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        .el-icon-document::before {
          content: '';
          display: inline-block;
          width: 12px;
          height: 12px;
          background: url('../../assets/images/excel.png') no-repeat center;
          background-size: contain;
          vertical-align: middle;
        }
      }
    }
    .progress-box {
      margin-top: 5px;
      /deep/ .el-progress-bar__inner {
        background: var(--g-color-primary) !important;
      }
      .progress-text {
        color: var(--g-color-primary);
        font-size: 12px;
        margin-top: 6px;
      }
    }
  }
  .circle {
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    color: #FFFFFF;
    background: var(--g-color-primary);
    border-radius: 50%;
    margin-right: 4px;
  }
  .bold {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-data-import/index.vue